import { round } from './_helper';
import { setDeliveryFee } from './_dashboard';
import ProductDetails from '../../../_modules/product-details/product-details';

/*** Define payment on create regimen
**** Display details on .summary-dashboard
**/
let $institutionAmount = $('.institution-amount'),
    $formPaymentSummary = $('.form--payment .summary .num'),
    $customerAmount = $('.customer-amount'),
    $institutionPercentage = $('.institution-percentage'),
    $customerPercentage = $('.customer-percentage'),
    $poNumberContainer = $('.po-number'),
    $urgentOrderContainer = $('.urgent-order__container'),
    $summaryPayment = $('.summary--payment-details'),
    $summaryPayInstitution = $('.summary__payment-institution'),
    $summaryPayClient = $('.summary__payment-client'),
    $summaryPayTotal = $('.summary__payment-total'),
    $summaryPaymentOption = $('.summary__payment-option'),
    $paymentMethod = $('#payment-method'),
    $paymentClient = $('#payment-client'),
    $paymentReverseClient = $('#payment-reverse-client'),
    $paymentFlatClient = $('#payment-flat-client'),
    $paymentReverseInstitution = $('#payment-reverse-institution'),
    $paymentFlatInstitution = $('#payment-flat-institution'),
    $paymentInstitution = $('#payment-institution'),
    $paymentAdmin = $('#payment-administration'),
    $paymentTransaction = $('#payment-transaction'),
    $paymentGst = $('#payment-gst'),
    $paymentDelivery = $('#payment-delivery'),
    $gst = $('#gst'),
    $flatRule = $('#payment-flat-rule'),
    $reverseRule = $('#payment-reverse-rule'),
    $deliveryFee = $('.delivery-fee'),
    isMobileDevice = Modernizr.mq('(max-width: 767px)'),
    canPlaceUrgentOrder = $('#CanPlaceUrgentOrder').val(),
    $requiresHcpApproval = $('#RequiresHcpApproval'),
    $isFirstFree = $('#IsFirstOrderFree'),
    institutionAmount = 0,
    customerAmount = 0,
    isCreateRegimen = $('.dashboard').length,
    deliveryFee,
    total, // this is total of PRODUCTS only
    isNdis = $(".is-ndis").length > 0;

$(document).ready(function(){
    if($('.view-regimen').length > 0){
        var option = $('#PaymentOption').attr('class').split(' ').pop();
        var option = "js-toggle-" + option;
        switch (option){
            case 'js-toggle-all-free':
                  $('.js-toggle-all-free').addClass('active');
                  toggleAllFree($('.js-toggle-all-free'));
               break;
            case 'js-toggle-hospital-auto-pay':
            case  'js-toggle-hospital-manual-pay':
                  $('.js-toggle-hospital').addClass('active');
                  calculateAmounts('hospital');
                break;
            case 'js-toggle-split-payment':
                  $('.js-toggle-copayment').addClass('active');
                  toggleSplitPayment($('.js-toggle-split-payment'));
                break;
            case 'js-toggle-flat-payment':
                    $('.js-toggle-copayment').addClass('active');
                    toggleFlatPayment($('.js-toggle-flat-payment'));
                break;
            case 'js-toggle-reverse-payment':
                    $('.js-toggle-copayment').addClass('active');
                    toggleReversePayment($('.js-toggle-reverse-payment'));
                break;
            case 'js-toggle-customer':
                    $('.js-toggle-customer').addClass('active');
                    toggleCustomer($('.js-toggle-customer'));
                break;
        }
    }
});

let isNdisPayLater = function(isContinue) {
    //let noOfOrders = $(".product-details__header .counter-value").val();
    displayPayContinue(isNdis ? true : isContinue);
}

/* Expand dropdown if payment method has more than one option.
** Available for "Institution pays" and "Co-Payment" */
$('.payment__list .btn').on('click', function (e) {
    e.preventDefault();

    let $this =  $(this),
        hasDropdown = $this.siblings().length;

    $('.payment__list .btn').removeClass("active");

    $this.addClass("active");

    //display dropdown
    if (hasDropdown) {
        var $list = $this.siblings('.payment__dropdown');

        if($list.is(':hidden')){
            $list.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                    queue: false
            });
        }
    }

    if (isCreateRegimen) {
        // Display Payment Summary on .summary-dashboard.
        $summaryPayment.fadeIn({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }
}).on('blur', function(e) {
    var $this = $(this),
        hasDropdown = $this.siblings().length;

    if(hasDropdown){
        var $list = $this.siblings('.payment__dropdown');

        $list.slideUp({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });
    }
});

/***** payment option: INSTITUTION PAYS ******/
//Display confirmation popup
$('.js-toggle-hospital-auto-pay,.js-toggle-hospital-manual-pay').on('click', function (e) {
    e.preventDefault();

    $('.payment__list li').removeClass("pay-selected");
    $(this).addClass("pay-selected");

    $.fancybox.open('#confirm-payment', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });

});

//If user agrees, proceed to set institution pays as selected method
// and display ampunts accordignly
$('.js-confirm-payment').on('click', function (e){
    e.preventDefault();

    if(isCreateRegimen){

        if($('#StartToday').prop('checked'))
            displayPayContinue(true);
    }

    $.fancybox.close();

    calculateAmounts('hospital');
});

//If user doesn't agree, undo selection and values
$('.js-undo-hospital-pays').on('click', function(e){
    e.preventDefault();

    $('.js-toggle-hospital').removeClass('active');
    $('.payment__list li').removeClass("pay-selected");

    $institutionAmount.text('');
    $customerAmount.text('');
    $institutionPercentage.text('');
    $customerPercentage.text('');

    $.fancybox.close();

    if(isCreateRegimen){
        if($('#StartToday').prop('checked'))
            isNdisPayLater(false);
            // displayPayContinue(isNdis ? true : false);
    }
});


/***** payment option: CUSTOMER PAYS ******/
$('.js-toggle-customer').on('click', function (e) {
    e.preventDefault();
    toggleCustomer($(this));
});

let toggleCustomer = function(el){
  if(isCreateRegimen){

      if($('#StartToday').prop('checked'))
        isNdisPayLater(false);
        //   displayPayContinue(isNdis ? true : false);
  }

  $('.payment__list li').removeClass("pay-selected");
  el.parent().addClass("pay-selected");

  calculateAmounts('client');
};

/***** payment option: CO-PAYMENT ******/
// Co-payment option: Percentage split
$('.js-toggle-split-payment').on('click', function (e) {
    e.preventDefault();
    toggleSplitPayment($(this));
});

let toggleSplitPayment = function(el){
  let rule = el.data('value');

  if (isCreateRegimen) {
      if ($('#StartToday').prop('checked')) {
        isNdisPayLater(false);
        //   displayPayContinue(isNdis ? true : false);
      }
  }

  calculateAmounts('split', rule);

  $('.payment__list li').removeClass("pay-selected");
  el.addClass("pay-selected");
};

// Co-payment option: Flat fee
$('.js-toggle-flat-payment').on('click', function (e) {
    e.preventDefault();
    toggleFlatPayment($(this));
});

let toggleFlatPayment = function(el){
  let rule = el.data('value');

  if(isCreateRegimen){

      if($('#StartToday').prop('checked'))
        isNdisPayLater(false);
        //   displayPayContinue(isNdis ? true : false);
  }

  calculateAmounts('flat', rule);

  $('.payment__list li').removeClass("pay-selected");
  el.addClass("pay-selected");
}

// Co-payment option: Reverse flat fee
$('.js-toggle-reverse-payment').on('click', function (e) {
    e.preventDefault();
    toggleReversePayment($(this));
});

let toggleReversePayment = function(el){
  let rule = el.data('value');

  if(isCreateRegimen){

      if($('#StartToday').prop('checked'))
        isNdisPayLater(false);
        //   displayPayContinue(isNdis ? true : false);
  }

  calculateAmounts('reverse', rule);

  $('.payment__list li').removeClass("pay-selected");
  el.addClass("pay-selected");
}

/***** payment option: ALL FREE ******/
$('.js-toggle-all-free').on('click', function (e) {
    e.preventDefault();
    toggleAllFree($(this));
});

let toggleAllFree = function(el){
  if(isCreateRegimen){
      displayPayContinue(true);
      $('.receipt--gst-total').text(0);
  }

  calculateAmounts('allFree');

  $('.payment__list li').removeClass("pay-selected");
  el.parent().addClass("pay-selected");
}

/* Update amounts if Payment option has been selected and IsFirstOrderFree is checked/unchecked.
** Make sure you trigger the event on the right item */
$isFirstFree.on('change', function(){
    let $selectedOption = $('.pay-selected');

    if($selectedOption.length != 0) {
        if ($selectedOption.has('.btn').length != 0) {
            $selectedOption.find('.btn').trigger('click');
        } else {
            $selectedOption.trigger('click');
        }
    } else {
        return false;
    }
});

/* Based on selected method, calculate client/institution amount accordingly.
** Display values in the payment summary and summary */
let calculateAmounts = function(option, rule){

    let institutionPercentage = '(0)',
        customerPercentage = '(0)',
        optionSelected = '',
        values = {};

    let adminFee = administrationFee(),
        transFee;

    if(!isCreateRegimen){
        total = Number($('#NextOrderTotal').val());
        deliveryFee = 0;
    }
    else{
        total = calculateTotalNoDelivery();
        setDeliveryFee();
        deliveryFee = Number($deliveryFee.text());
    }

    $paymentMethod.val(option);

    // Calculate transaction fee, if applied
    // need to be before admin fees, as it shouldn't include gst applied on admin fee
    switch (option){
        case 'allFree':
           adminFee = 0;
           transFee = 0;
           deliveryFee = 0;
           $('.receipt--delivery-total').text('0');
           break;
        case 'hospital':
            transFee = 0;
            break;
        case 'split':
            customerAmount = splitValues(rule, total, 0, 0).customerAmount;
            transFee = transactionFee(customerAmount);
            break;
        case 'flat':
            customerAmount = flatValues(rule, total, 0, 0).customerAmount;
            transFee = transactionFee(customerAmount);
            break;
        case 'reverse':
            customerAmount = reverseValues(rule, total, 0, 0).customerAmount;
            transFee = transactionFee(customerAmount);
            break;
        case 'client':
            customerAmount = total;
            transFee = transactionFee(customerAmount);
            break;
    }

    // add fees
    let finalTotal = total + adminFee + transFee;

    // set values to display in the payment summary
    switch (option){
        case 'allFree':
            customerAmount = 0;
            institutionAmount = 0;
            adminFee = 0;
            transFee = 0;
            $paymentInstitution.val(0);
            $paymentClient.val(0);
            optionSelected = 'All Orders are Free';
            break;
        case 'hospital':
            finalTotal += deliveryFee;
            customerAmount = 0;
            institutionAmount = finalTotal;
            institutionPercentage = '100%';
            $paymentInstitution.val(1);
            $paymentClient.val(0);
            optionSelected = 'Payment Option selected: Hospital Pays';
            break;
        case 'split':
            finalTotal += deliveryFee;
            values = splitValues(rule, total, adminFee, transFee);
            institutionAmount = values.institutionAmount;
            customerAmount = values.customerAmount;
            institutionPercentage = values.institutionPercentage;
            customerPercentage = values.customerPercentage;
            optionSelected = 'Payment Option selected: Institution pays ' + institutionPercentage + ', Client pays ' + customerPercentage;
            break;
        case 'flat':
            values = flatValues(rule, total, adminFee, transFee);
            finalTotal += deliveryFee;
            institutionAmount = values.institutionAmount;
            customerAmount = values.customerAmount;
            institutionPercentage = values.institutionPercentage;
            customerPercentage = values.customerPercentage;
            $paymentInstitution.val(0);
            $paymentClient.val(0);
            optionSelected = 'Payment Option selected: Flat fee';
            break;
        case 'reverse':
            values = reverseValues(rule, total, adminFee, transFee);
            finalTotal += deliveryFee;
            institutionAmount = values.institutionAmount;
            customerAmount = values.customerAmount;
            institutionPercentage = values.institutionPercentage;
            customerPercentage = values.customerPercentage;
            optionSelected = 'Payment Option selected: Reverse flat fee';
            break;
        case 'client':
            finalTotal += deliveryFee;
            customerAmount = finalTotal;
            customerPercentage = '(100%)';
            institutionAmount = 0;
            optionSelected = 'Payment Option selected: Client Pays';
            break;
    }

    //set both amount to zero if First Order is Free
    isFirstOrderFree();
    if($isFirstFree.prop('checked')){
        adminFee = 0;
        transFee = 0;
        deliveryFee = 0;
        finalTotal = 0;
    }

    //round values to 2 decimal places
    finalTotal = round( finalTotal, 2);
    institutionAmount = round(institutionAmount, 2);
    customerAmount = round(customerAmount, 2);
    transFee = round(transFee, 2);

    $paymentAdmin.val(adminFee);
    $paymentTransaction.val(transFee);
    $paymentGst.val($gst.val());



    // display amounts on payment summary
    $institutionAmount.text('$ ' + institutionAmount);
    $customerAmount.text( '$ ' + customerAmount);

    $institutionPercentage.text( institutionPercentage );
    $customerPercentage.text( customerPercentage );

    if (isCreateRegimen) {

        $formPaymentSummary.text(finalTotal);

        //display transaction fee in the payment summary
        $('.receipt--transaction-total').text(transFee);
        $('.receipt--administration-total').text(adminFee);

        // Display summary in the multi-setp nav
        $summaryPaymentOption.text(optionSelected);
        $summaryPayInstitution.text('$' + institutionAmount);
        $summaryPayClient.text('$' + customerAmount);
        $summaryPayTotal.text('$' + finalTotal);
    }

    //display PO Number if option == 'institution' OR 'any co-payment'
    displayPoNumber(option);
    displayUrgentOrder(option);
};

let splitValues = function(rule, totalProductAmount, adminFee, transFee){
    let totalProducts = totalProductAmount,
        splitClient = rule,
        splitInstitution = 1 - splitClient,
        institutionPays = totalProducts * splitInstitution,
        customerPays = totalProducts * splitClient,
        customerPercentage = round((splitClient*100) , 2) + '%',
        institutionPercentage = round((splitInstitution*100), 2) + '%',
        values = {};

    // assign delivery fee based on total
    if(customerPays > 0){
        customerPays += deliveryFee;
        customerPays += adminFee;
        customerPays += transFee;
        customerPercentage += " plus fees";
    }
    else{
        institutionPays += deliveryFee;
        customerPays += adminFee;
        institutionPercentage += " plus fees";
    }

    $paymentClient.val(round(splitClient,2));
    $paymentInstitution.val(round(splitInstitution,2));
    values.institutionAmount = institutionPays;
    values.customerAmount = customerPays;
    values.institutionPercentage = institutionPercentage;
    values.customerPercentage = customerPercentage;
    return values;
};

let flatValues = function(rule, totalProducts, adminFee, transFee){

    let total = totalProducts,
        institutionPays = 0,
        customerPays = 0,
        firstCustomerPays = parseFloat(rule),
        values = {};

    // assign delivery fee on client since they will always pay
    if(total <= firstCustomerPays){
        customerPays = parseFloat(total) + deliveryFee + adminFee + transFee;
        institutionPays = 0;
    } else {
        customerPays = firstCustomerPays + deliveryFee + parseFloat(adminFee) + parseFloat(transFee);
        institutionPays = parseFloat(total) - firstCustomerPays;
    }


    values.institutionAmount = institutionPays;
    values.customerAmount = customerPays;
    values.institutionPercentage = ' ';
    values.customerPercentage = '(First $' + firstCustomerPays + ' plus fees)';

    $paymentFlatClient.val(customerPays);
    $paymentFlatInstitution.val(institutionPays);
    $flatRule.val(parseFloat(rule));

    return values;
};

let reverseValues = function(rule, productsTotal, adminFee, transFee){
    let total = productsTotal,
        institutionPays = 0,
        customerPays = 0,
        firstHospitalPays = parseFloat(rule),
        values = {};

    $reverseRule.val(firstHospitalPays);

    // assign delivery fee based on total, client will pay delivery if customerPays > 0
    if(total <= firstHospitalPays){
        customerPays = 0;
        institutionPays = parseFloat(total) + deliveryFee + adminFee;
        values.institutionPercentage = '(First $' + firstHospitalPays + ' plus fees)';
        values.customerPercentage =  ' ';
    } else{
        customerPays = parseFloat(total) - firstHospitalPays + deliveryFee + adminFee + transFee;
        institutionPays = firstHospitalPays;
        values.institutionPercentage = '(First $' + firstHospitalPays + ')';
        values.customerPercentage =  '(including fees)';
    }

    $paymentReverseClient.val(customerPays);
    $paymentReverseInstitution.val(institutionPays);

    values.institutionAmount = institutionPays;
    values.customerAmount = customerPays;
    return values;
};

/* When this is checked, everything is free - Order will be $0.
** User still needs to select payment rule*/
let isFirstOrderFree = function(){
    if($isFirstFree.prop('checked')){
        institutionAmount = 0;
        customerAmount = 0;
        $('.receipt--gst-total').text(0);
        $('.receipt--delivery-total').text(0);
    }
    else
        return false;
};


/* Admin fee: added to the Order at ALL times regardless of the payment rule selected */
let administrationFee = function() {
    let $administrationFee = $('#AdministrationFee'),
        adminFee = parseFloat($administrationFee.val()),
        isGstOnAdminFee = $administrationFee.data('gst-applicable'),
        gst = parseFloat($('#gst').val());

    // Calculate administration fee, if applied
    if (adminFee > 0 && customerAmount > 0) {
        if(isGstOnAdminFee){
            adminFee *= (1 + gst);
        }
        //convert into dollar, as the amount is in Cents
        adminFee *= 0.01;
    }
    else{
      adminFee = 0;
    }


    adminFee = round(adminFee, 2);
    //display administration fee in the payment summary
    $('.receipt--administration-total').text(adminFee);

    return adminFee;
};

/* Transaction fee:
** - value represents the percentage to apply to total Order amount (including administration fee, excluding GST)
** - only applied if the amount that client needs to pay is greater than 0 */
let transactionFee = function(customerAmount){
    let $transactionFee = $('#TransactionFee'),
        transFee = parseFloat($transactionFee.val()),
        isGstOnTransFee = $transactionFee.data('gst-applicable'),
        gst = parseFloat($('#gst').val());

    if ( transFee > 0 && customerAmount > 0){

        transFee = customerAmount * transFee;

    }
    else{
        // need to define value, otherwise it will consider the value defined in the hidden input
        transFee = 0;
    }

    return transFee;
};


/* Hide/Show payment buttons: : display "continue"
** - if payment option is "Institution pays" AND "Regimen Start Date Today"
** - if is "Regimen Start Date Later"
** - if CS needs HCP Approval
** - if Orders are free
*/
let displayPayContinue = function(isContinue){
    if(isContinue || $requiresHcpApproval.prop('checked') || $isFirstFree.prop('checked')){
        $('.js-pay-continue').css('display', 'inline-block');
        $('.js-pay-now').hide();
        $('.js-pay-later').hide();
    }
    else{
        $('.js-pay-continue').hide();
        $('.js-pay-now').show();
        $('.js-pay-later').show();
    }
};

/* Calculate total for products puchased first month
** Needed for copayment, since the delivery fee won't be included in the total */
let calculateTotalNoDelivery = function(){

    let $productDetail = $('.phase--wrapper.active .product-details:first-child .product-details__row'),
        totalPrice = 0,
        total = 0;

    let prodDetails = new ProductDetails();

    $productDetail.each(function (e) {
        let $this = $(this),
            $productQty = Number($this.find('.product-quantity__value .counter-value').val()),
            $price = Number($this.data('price')),
            $productTotal = $productQty * $price,
            $singlePrice = Number($this.data('single-price')),
            $cartonSize = Number($this.data("cartonsize")),
            $isSpecial = $this.data('is-special'),
            $counterVal = $this.find('.counter-value').val(),
            $productPrice = $this.find('.product-price__total').val(),
            prodTotal = 0;

        totalPrice += prodDetails.calculateProductTotal($price, $singlePrice, $productQty, $cartonSize);
        // totalPrice += Number($productTotal);
    });

    return round(totalPrice, 2);
};


/* Display PO Number if Institution has to pay any amount.
** Available if it is institution pays or copays */
let displayPoNumber = function(option){

    if(option != 'allFree' && option != 'client'){
        $poNumberContainer.slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }
    else{
        $poNumberContainer.slideUp({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }
};

/* Display Urgent Order only if
** - user is allowed to set the value
** - client agrees to receive calls ('IsDoNotCallOpted' is not checked)
** - it is customer pay or co-payment */
let displayUrgentOrder = function(paymentOption){

    let isDoNotCall = $('#IsDoNotCallOpted').prop('checked');

    if(!canPlaceUrgentOrder || isDoNotCall){
        return false;
    }
    else{
        if(paymentOption == 'hospital' || paymentOption == 'allFree'){
            $urgentOrderContainer.slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        }else{
            $urgentOrderContainer.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        }
    }
};

export { displayPayContinue, flatValues, reverseValues }
